// Helper for opening external "Visit on X" / "Order Now" links from Bud Link.
//
// Problem: iOS PWAs (Bud Link installed to home screen) open `target="_blank"`
// links inside SFSafariViewController — a stripped-down in-app browser that
// disables Service Workers, blocks 3rd-party cookies, and has aggressive
// resource timeouts. Heavy ecommerce frontends like Trulieve (Adobe Magento)
// and Sunnyside (Adobe Commerce) can't hydrate inside that sandbox, so the
// user lands on a half-styled / broken-looking page.
//
// Fix: when running as a standalone PWA, drop `target="_blank"` so iOS hands
// the URL off to real Safari (full feature support). Single swipe-back
// returns to Bud Link. Outside the PWA (regular browser tab), keep
// `target="_blank"` so desktop/mobile browser users get a new tab as expected.
const isStandalone = () => {
  if (typeof window === "undefined") return false;
  try {
    if (window.matchMedia?.("(display-mode: standalone)").matches) return true;
    if (window.navigator?.standalone === true) return true;
  } catch {
    return false;
  }
  return false;
};

export const externalLinkProps = (href) => ({
  href,
  target: isStandalone() ? undefined : "_blank",
  rel: "noopener noreferrer",
});
